import { render, staticRenderFns } from "./EmdAlert.vue?vue&type=template&id=6fabe452&"
import script from "./EmdAlert.vue?vue&type=script&lang=js&"
export * from "./EmdAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports